import clsx from 'clsx';
import React from 'react';
import MessageCandidate from './MessageCandidate';
import { useNavigate } from 'react-router-dom';
import { getLinkUserProfile } from '../../pages/Chat/ChatContent';

function ChatMessLeft({ setOpenUser, candidate, content_type, text, from_user, created_at, isSelf }) {
  const navigate = useNavigate();
  return (
    <div>
      <div className="chat-message mt-4">
        <div className={clsx('flex items-center justify-start', isSelf ? ' flex-row-reverse' : '')}>
          {content_type == 'candidate' ? (
            <MessageCandidate isSelf={isSelf} created_at={created_at} name={candidate?.full_name} id={candidate?.id} setOpenUser={setOpenUser} senderName={from_user?.full_name} />
          ) : (
            <div className="flex flex-col space-y-2 text-xs max-w-xs mx-2 order-2 items-start">
              <div>
                <span style={{ ...(isSelf && { background: 'rgba(0,178,164,0.2)', paddingTop: '6px' }) }} className="px-4 py-2 rounded-lg inline-block bg-gray-100 text-gray-500 flex flex-col">
                  {!isSelf && (
                    <div className="text-black font-medium -mt-1 " style={{ fontSize: '10px' }}>
                      {from_user?.full_name}
                    </div>
                  )}

                  <div className="-mt-[2px] mb-[2px]">{text}</div>
                  <div className="text-gray-400 self-end" style={{ fontSize: '10px' }}>
                    {created_at}
                  </div>
                </span>
              </div>
            </div>
          )}

          <div
            className="w-6 h-6 rounded-full order-1 self-end cursor-pointer"
            style={{ border: isSelf ? '1px solid rgba(0, 178, 164, 0.2)' : '1px solid rgb(229, 231, 235)', display: 'flex', alignItems: 'center', justifyContent: 'center', ...(content_type == 'candidate' && { marginBottom: '19px' }) }}
            onClick={() => {
              navigate(getLinkUserProfile({ type: from_user?.type, id: from_user?.id }));
            }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" viewBox="0 0 24 24">
              <path fill={isSelf ? 'rgb(0, 178, 164)' : 'rgba(0,0,0,0.6)'} d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4"></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChatMessLeft;
